import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import { mapData, handleRedirectInternal } from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import CommunicationContext from '@/product/context/communication/communicationContext'
let randomVariable = Math.random()
const TemplateManage = (props) => {
    const communicationContext = useContext(CommunicationContext)
    const [isLoading, setIsLoading] = useState(true)
    const { single_static_page, getSingleStaticPage, staticPageAction } =
        communicationContext
    const [isReload, setIsReload] = useState(true)
    const data = props.data
    const toggleFullScreenPopup = props.function

    const validationArray = Yup.object({
        content_type: Yup.string().required('Required!'),
        content: Yup.string().when('content_type', {
            is: 'html',
            then: Yup.string().required('Required!'),
        }),
        content_arabic: Yup.string().when('content_type', {
            is: 'html',
            then: Yup.string().required('Required!'),
        }),
        file_path: Yup.array().when('content_type', {
            is: 'file',
            then: Yup.array().required('Required!'),
        }),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            name: '',
            content: '',
            content_arabic: '',
            content_type: '',
            file_path: [],
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            // values.file_path = values.file_path[0]
            staticPageAction(values)
        },
    })

    // useEffect(() => {
    //     resetFrom()
    // }, [props])

    useEffect(() => {
        if (data.status === 'edit') {
            formik.values.id = data.id
            randomVariable = Math.random()
            getSingleStaticPage(formik.values, randomVariable)
        } else {
            resetFrom()
        }
    }, [data.id])

    const resetFrom = () => {
        formik.values.id = 0
        formik.values.name = ''
        formik.values.content = ''
        formik.values.content_type = ''
        formik.values.content_arabic = ''
        formik.resetForm()
        formik.handleReset()
    }
    useEffect(() => {
        if (
            single_static_page.record &&
            data.status === 'edit' &&
            single_static_page.from == randomVariable
        ) {
            // resetFrom()
            formik.values.id = data.id

            const template = single_static_page.record
            template.file_path =
                template.file_path && !Array.isArray(template.file_path)
                    ? template.file_path.split(',')
                    : []
            template.content_arabic = template.content_arabic
                ? template.content_arabic
                : ''
            template.content = template.content ? template.content : ''
            formik.setValues({ ...template })

            formik.values.file_path = template.file_path
            formik.values.content = single_static_page.record?.content
                ? single_static_page.record.content
                : ''
            if (single_static_page?.record?.content_arabic) {
                console.log('coming inside')
                formik.values.content_arabic =
                    single_static_page?.record?.content_arabic
            } else {
                formik.values.content_arabic = ''
            }
            setIsReload(!isReload)
        } else {
            resetFrom()
        }
        setIsLoading(false)
    }, [single_static_page])

    const emailTemplate = []

    if (data.status === 'new') {
        emailTemplate.push({
            label: 'Title',
            placeholder: 'Enter Title',
            class: 'col-12',
            type: 'text',
            shrink: true,
            name: 'name',
            formik: formik,
        })
    }
    emailTemplate.push(
        {
            class: 'col-12',
            name: 'content_type',
            type: 'select',
            placeholder: 'Select Content Type',
            options: [
                { show: 'HTML', value: 'html' },
                { show: 'FILE', value: 'file' },
            ],
            formik: formik,
        },
        {
            type: 'uploadDropZone',
            formik: formik,
            name: 'file_path',
            icon: 'description',
            titleText: 'Upload Static File document',
            class: `${
                formik.values.content_type === 'file' ? '' : 'd-none'
            } col-12`,
            folder: 'static_files',
            multiple: false,
            accept: '.pdf',
        },
        {
            type: 'misc',
            class: `${
                formik.values.content_type === 'html' ? '' : 'd-none'
            } col-12`,
            content: <div className=" regDivider">English: </div>,
        },
        {
            class: `${
                formik.values.content_type === 'html' ? '' : 'd-none'
            } col-12`,
            name: 'content',
            type: 'ckeditor5',
            formik: formik,
        },
        {
            type: 'misc',
            class: `${
                formik.values.content_type === 'html' ? '' : 'd-none'
            } col-12`,
            content: <div className=" regDivider">Arabic: </div>,
        },
        {
            class: `${
                formik.values.content_type === 'html' ? '' : 'd-none'
            } col-12`,
            name: 'content_arabic',
            type: 'ckeditor5',
            formik: formik,
        }
    )

    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? 'ADD NEW STATIC PAGE'
                    : `EDIT STATIC PAGE: ${single_static_page.record.name}`
            }
            open={data.popup}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                        <div className="row">
                            {Object.values(mapData(emailTemplate))}
                        </div>
                        {isLoading && <div>Loading....</div>}
                        <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                            <SecondaryButton
                                label="Cancel"
                                id="staticManage_cancel"
                                onClick={() => toggleFullScreenPopup(false)}
                            />
                            <PrimaryButton
                                id="staticManage_submit"
                                type="submit"
                                label="Submit"
                            />
                        </div>
                    </form>
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default TemplateManage
